import { Switch } from "antd";
import { useState } from "react";
import colors from "../../../theme/colors";
import { GroupData } from "../../dashboard/BasicInformation/BasicInformation";

const Toggle = ({
  group,
  onChange,
  defaultText,
  checkedText,
}: {
  group: GroupData;
  onChange: (checked: boolean, group: GroupData) => void;
  defaultText?: string;
  checkedText?: string;
}) => {
  const [checked, setChecked] = useState<boolean | undefined>(group?.selected);

  const handleToggle = (checked: boolean, event: any) => {
    setChecked(checked);
    onChange(checked, group);
  };

  return (
    <>
      <Switch
        onChange={handleToggle}
        checked={checked}
        style={{
          backgroundColor: checked ? colors.success : colors.border,
        }}
      />
      {defaultText && checkedText && (
        <span className="toggle-label">
          {checked ? checkedText : defaultText}{" "}
        </span>
      )}
    </>
  );
};

export default Toggle;
